import { styled } from '@mui/material';
import { formControlLabelClasses } from '../FormControl';
export const SelectAllBox = styled('div')(({ theme }) => ({
    paddingInline: theme.spacing(2),
    [`.${formControlLabelClasses.root}`]: {
        marginLeft: -1,
    },
}));
